import { Hero, OrbitMark } from '@components/SignInCard'
import React from 'react'
import { JoinInvitation } from './core'
import {
	InviterAvatar,
	Going,
	Inviter,
	Meta,
	TripName,
} from './JoinTripPage.styles'

/** The invitation itself, on the card's blue hero: who, which trip, when, how many. */
const InvitationPanel: React.FC<{ invitation: JoinInvitation }> = ({ invitation }) => {
	const meta = [invitation.dateRange, invitation.dayLabel].filter(Boolean).join(' · ')

	return (
		<Hero>
			<Inviter>
				<InviterAvatar src={invitation.inviterAvatarUrl} label={invitation.inviterInitial} size="lg" />
				<p>
					<b>{invitation.inviterName}</b> has invited you to join
				</p>
			</Inviter>

			<TripName>{invitation.tripName}</TripName>
			{meta && <Meta>{meta}</Meta>}
			<Going>{invitation.goingLabel}</Going>

			<OrbitMark />
		</Hero>
	)
}

export default InvitationPanel
